import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./EventUsers.scss";

import { EventUser } from './EventUser/EventUser';
import { useBeam } from '@randajan/bifrost/client/react';
import { globalStatsBeam } from '../../../../assets/beams/globalStatsBeam';
import { pickUser } from '../../../../assets/bifrost';
import { Counter } from '@randajan/jet-react/dom/counter';
import { eventSignBeam } from '../../../../assets/beams/eventSignBeam';
import { meBeam } from '../../../../assets/beams/meBeam';
import { eventBeam } from '../../../../assets/beams/eventBeam';
import { Locale } from '../../../../assets/Locale';

export const EventUsers = (props) => {
    const { eventId } = props;
    const say = Locale.use();

    const { data:me } = useBeam(meBeam);
    const { data:event } = useBeam(eventBeam, [eventId]);
    const { data:eventSign } = useBeam(eventSignBeam, [eventId]);
    const { data:stats } = useBeam(globalStatsBeam);

    const { gameEventUsers } = (event || {});

    return (
        <Block className="EventUsers" caption={say("eventUsersCaption")}>
            <div className="users">
                {gameEventUsers?.map((geu, key) => {
                    let user = geu.sysUser;
                    if (eventSign?.mySign?.id === geu.id) { user = me }
                    else { user = pickUser(stats, geu.sysUser?.aliasKey) || geu.sysUser; }
                    return <EventUser key={key} {...geu} sysUser={user} />;
                })}
            </div>
        </Block>
    )
}

